<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-foreword has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/forewordmysticrhythms"><span class="item-title-text">Foreword: Mystic Rhythms</span></a></p>
<p class="item-author">Kevin J. Anderson</p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/drumbeats" title="Link target outside of Sample"><span class="item-title-text">Drumbeats</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-afterword has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/afterwordstoriesthatfiredmyimagination"><span class="item-title-text">Afterword: Stories That Fired My Imagination</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheauthors"><span class="item-title-text">About the Authors</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheartist"><span class="item-title-text">About the Artist</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/ifyouliked"><span class="item-title-text">If You Liked …</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/otherwordfirepresstitlesbykevinjanderson"><span class="item-title-text">Other WordFire Press Titles by Kevin J. Anderson</span></a></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d9bc0efa